<template>
  <v-dialog
    :value="value"
    overlay-color="#000"
    overlay-opacity="0.66"
    :persistent="true"
    :max-width="600"
    @input="handleDialogInput"
  >
    <v-card class="dialog-card">
      <v-card-title class="d-flex justify-space-between dialog-title-close">
        Nahrať dokument
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-combobox
          class="dynamic-input-control"
          :items="typyDokumentovItems"
          :disabled="defaultTypDokumentuId != null"
          label="Typ dokumentu"
          item-text="nazov"
          outlined
          return-object
          v-model="typDokumentuSelected"
        ></v-combobox>

        <v-textarea
          class="dynamic-input-control"
          name="textareaPoznamka"
          filled
          label="Poznámka"
          auto-grow
          no-resize
          rows="3"
          outlined
          v-model="poznamka"
        ></v-textarea>

        <upload-area ref="refuploadarea"></upload-area>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="btn-secondary ml-5" @click="closeDialog">
          Späť
        </v-btn>
        <v-btn
          class="btn-primary"
          @click="dmsSave()"
          :disabled="uloadujemData"
        >
          <v-icon left>mdi-upload-outline</v-icon>
          Nahrať
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import protectedAxios from '../../auth/axios';
import UploadArea from '../basic/UploadArea.vue';

export default {
  components: {
    UploadArea,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    newId: {
      type: [String, Number],
      default: null,
    },
    cisloPredmetu: {
      type: [String, Number],
      default: '0',
    },
    defaultTypDokumentuId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      poznamka: '',
      typDokumentuSelected: null,
      typyDokumentovItems: [],
      uloadujemData: false,
      cisloLz: ''
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.initializeDialog();
        }
      },
    },
    newId(val, oldVal) {
      if (this.value && val !== oldVal) {
        this.initializeDialog();
      }
    },
  },
  methods: {
    handleDialogInput(val) {
      if (!val) {
        this.closeDialog();
      }
    },
    async initializeDialog() {
      this.resetState();
      await this.loadTypyDokumentov();
    },
    async loadTypyDokumentov() {
      if (!this.newId) {
        this.typyDokumentovItems = [];
        return;
      }

      try {
        const res = await protectedAxios.get(`dokumenty/getcisdokladyupload/${this.newId}`);
        this.typyDokumentovItems = res.data ?? [];
        this.setDefaultTypDokumentu();
      } catch (e) {
        console.error(e);
        this.typyDokumentovItems = [];
      }
    },
    setDefaultTypDokumentu() {
      if (this.defaultTypDokumentuId != null) {
        this.typDokumentuSelected =
          this.typyDokumentovItems.find(
            item => String(item.dms_id_typu_dokumentu) === String(this.defaultTypDokumentuId)
          ) ?? null;
        if (this.typDokumentuSelected) {
          return;
        }
      }
    },
    dmsSave() {
      this.$refs.refuploadarea.filesSaved(() => {
        this.uloadujemData = false;
        this.$emit('uploaded');
        this.closeDialog();
      });
      this.$refs.refuploadarea.filesNotSaved(() => {
        this.uloadujemData = false;
      });
      this.uloadujemData = true;
      this.$refs.refuploadarea.save(
        this.typDokumentuSelected?.dms_id_typu_dokumentu ?? 0,
        this.poznamka,
        this.newId,
        this.cisloLz,
        this.cisloPlz,
        this.cisloPredmetu
      );
    },
    closeDialog() {
      this.clearUploadArea();
      this.resetState();
      this.$emit('input', false);
      this.$emit('closed');
    },
    resetState() {
      this.poznamka = '';
      this.typDokumentuSelected = null;
      this.uloadujemData = false;
    },
    clearUploadArea() {
      if (!this.$refs.refuploadarea) {
        return;
      }

      this.$refs.refuploadarea.errorMessage = '';
      this.$refs.refuploadarea.filesToUpload = [];
      this.$refs.refuploadarea.reset();

      if (this.$refs.refuploadarea.$refs.inputFile) {
        this.$refs.refuploadarea.$refs.inputFile.value = '';
      }
    },
  },
};
</script>
